import type { ShippingPolicyItem } from '../../../model/siteconfig/siteconfig';

export interface GetShippingPoliciesResponse {
  /** Configuration key */
  key: string;
  /** Configuration version (timestamp in seconds) */
  version: number;
  /** Array of shipping policies by country */
  config: ShippingPolicyItem[];
}
